import { render, staticRenderFns } from "./bound.vue?vue&type=template&id=35714238&scoped=true&"
import script from "./bound.vue?vue&type=script&lang=js&"
export * from "./bound.vue?vue&type=script&lang=js&"
import style0 from "./bound.vue?vue&type=style&index=0&id=35714238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35714238",
  null
  
)

export default component.exports